import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/store";

const initialState = {} as IDeviceAdmin;

const deviceAdminSlice = createSlice({
    name: "deviceAdmin",
    initialState,
    reducers: {
        setDeviceAdmin: (state, action: PayloadAction<IDeviceAdmin>) => {
            Object.assign(state, action.payload);
        },
        setDeviceAdminList: (state, action) => {
            Object.assign(state, action.payload);
        },
    },
});

export const { setDeviceAdmin, setDeviceAdminList } = deviceAdminSlice.actions;
export default deviceAdminSlice.reducer;

export const getDeviceAdmin = (state: RootState) => state.deviceAdmin;
